module.exports = __webpack_public_path__ + "6d4cc7c1601dd60243679e532f3dafec.m4a";